<template>
  <v-dialog
    v-model="visible"
    max-width="400"
    persistent
    contentClass="rounded-xl"
  >
    <v-card class="pa-4">
      <div v-if="!selectedUser">
        <h5>Selecione o operador que irá utilizar o terminal</h5>
        <v-card
          v-for="user in users"
          :key="user.id"
          @click="selectUser(user)"
          outlined
        >
          <v-alert class="mb-0" dense color="primary" text border="left" st>
            <div class="d-flex gap-4 align-center">
              <BaseAvatar :src="user.photo" :seed="user.userId" size="40" />
              <div class="flex-grow-1">
                <h5 class="mb-0">{{ user.name }}</h5>
                <small>{{ user.document }}</small>
              </div>
              <v-icon> mdi-chevron-right </v-icon>
            </div>
          </v-alert>
        </v-card>
      </div>
      <div v-else class="d-flex flex-column align-center">
        <v-btn
          v-if="users.length > 1"
          icon
          style="position: absolute; top: 16px; left: 16px"
          @click="selectedUser = null"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <BaseAvatar
          :src="selectedUser.photo"
          :seed="selectedUser.userId"
          size="80"
        />
        <h4 class="mb-0 mt-6">Olá, {{ selectedUser.name }}</h4>
        <h6 class="mb-0">
          {{
            selectedUser.password
              ? "Insira sua senha para continuar"
              : "Crie uma senha para continuar"
          }}
        </h6>
        <small> A senha é composta por 6 caracteres. </small>
        <v-otp-input
          ref="otp"
          v-model="password"
          length="6"
          class="mt-4"
          auto-focus
          :type="selectedUser.password ? 'password' : 'text'"
          @complete="login"
          :disabled="loading"
        ></v-otp-input>

        <v-alert v-if="error" type="error" class="mt-4 mb-0 w-full" dense>
          {{ error }}
        </v-alert>

        <v-btn
          class="mt-4"
          :loading="loading"
          :disabled="password.length < 6"
          color="primary"
          @click="login"
          block
          large
        >
          {{ selectedUser.password ? "Entrar" : "Criar Senha" }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import VIRTUAL_POS from "@/services/staff/virtualPos";
import md5 from "md5";

export default {
  name: "UserLoginModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedUser: null,
      password: "",
      loading: false,
      error: null,
    };
  },
  methods: {
    async login() {
      try {
        this.loading = true;
        this.error = null;
        const body = {
          userId: this.selectedUser.id,
          password: md5(this.password),
        };
        const { token, user } = await VIRTUAL_POS.login(this.token, body);
        this.$emit("login", { token, user });
      } catch (e) {
        this.error = e.message || "Erro ao realizar login";
      } finally {
        this.password = "";
        this.loading = false;
      }
    },
    selectUser(user) {
      this.selectedUser = user;
      this.$nextTick(() => {
        this.$refs.otp.focus();
      });
    },
  },
  watch: {
    password(newVal) {
      if (newVal.length != 6) return;
      if (this.loading) return;
      if (this.selectedUser.password) this.login();
    },
  },
  mounted() {
    if (this.users.length === 1) {
      this.selectedUser = this.users[0];
      this.$nextTick(() => {
        this.$refs.otp.focus();
      });
    }
  },
};
</script>
